import { useMemo } from "react";
import { useScheduleContext } from "./context/useScheduleContext";
import { useGroups } from "../../../Settings/General/OrganisationLevelGroups/context";

export const useDefaultLevel = () => {
    const { selectedCellOrEvent } = useScheduleContext();
    const { allocatedGroups } = useGroups();

    return useMemo(() => {
        const level = (allocatedGroups?.[0]?.level || "").replaceAll("_", "");
        return (selectedCellOrEvent?.user as any)?.[level];
    }, [allocatedGroups, selectedCellOrEvent]);
};
